import React from 'react'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { useTheme, makeStyles } from '@material-ui/core'

export const ContactButton = ({text}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Button className={classes.button} size="medium" href="tel:070-4040223">
      <Typography variant="body1">
        {text}
      </Typography>
    </Button>
  )
}

const useStyles = makeStyles({
  button: theme => ({
    backgroundColor: theme.palette.action.main,
    color: 'black',
    margin: '1rem 0',
    maxWidth: '30%'
  })
})